import { render, staticRenderFns } from "./MainHeaderNote.vue?vue&type=template&id=65aebf5c&scoped=true&lang=pug"
import script from "./MainHeaderNote.vue?vue&type=script&lang=js"
export * from "./MainHeaderNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aebf5c",
  null
  
)

export default component.exports